import { IRootState } from '@/store/state';
import { ActionContext, ActionTree } from 'vuex';
import { SubFundService } from '../services';
import * as AT from './actionTypes';
import * as MT from './mutationTypes';
import {
  SubFund,
  OrgSubFundRequest,
  PaginatedResult,
  AddSubFundRequest,
  UpdateSubFundRequest,
  DeleteSubFundRequest,
  SubFundCostRequest,
  AddNewReportingPeriodRequest,
  DeleteSubFundCostRequest
} from '../types';
import { ISubFundState } from './state';
import { SET_LOADER } from '../../organisation/store/mutationTypes';
/**
 * --------------------------------------------------
 *  SubFund Actions
 * --------------------------------------------------
 **/
export const SubFundAction: ISubFundActions = {
  [AT.FETCH_ORGANISATION_SUB_FUNDS]: (
    { commit },
    orgSubFundRequest: OrgSubFundRequest
  ): Promise<SubFund[]> => {
    commit(SET_LOADER, true);
    return SubFundService.getSubFunds(orgSubFundRequest).then(
      (paginatedResult: PaginatedResult) => {
        commit(MT.SET_PAGINATION_META, paginatedResult.meta);
        commit(MT.SET_ORGANIZATION_SUB_FUNDS, paginatedResult.data);
        commit(SET_LOADER, false);
        return paginatedResult.data;
      }
    );
  },
  [AT.FETCH_ORGANISATION_FILTER_SUB_FUNDS]: (
    { commit },
    orgSubFundRequest: OrgSubFundRequest
  ): Promise<SubFund[]> => {
    commit(SET_LOADER, true);
    return SubFundService.getFilterSubFunds(orgSubFundRequest).then(
      (filterSubFunds: SubFund[]) => {
        commit(MT.SET_ORGANIZATION_FILTER_SUB_FUNDS, filterSubFunds);
        commit(SET_LOADER, false);
        return filterSubFunds;
      }
    );
  },
  [AT.ADD_SUB_FUND]: (
    { commit },
    addSubFundRequest: AddSubFundRequest
  ): Promise<Response> => {
    return SubFundService.postSubFund(addSubFundRequest).then(
      (data: Response) => data
    );
  },
  [AT.UPDATE_SUB_FUND]: (
    { commit },
    updateSubFundRequest: UpdateSubFundRequest
  ): Promise<Response> => {
    return SubFundService.putSubFund(updateSubFundRequest).then(
      (data: Response) => data
    );
  },
  [AT.DELETE_SUB_FUND]: (
    { commit },
    deleteSubFundRequest: DeleteSubFundRequest
  ): Promise<Response> => {
    return SubFundService.deleteSubFund(deleteSubFundRequest).then(
      (data: Response) => data
    );
  },
  [AT.SUB_FUND_COST]: (
    { commit },
    subFundCostRequest: SubFundCostRequest
  ): Promise<Response> => {
    return SubFundService.postSubFundCost(subFundCostRequest).then(
      (data: Response) => data
    );
  },
  [AT.ADD_NEW_REPORTING_PERIOD]: (
    { commit },
    addNewReportingPeriodRequest: AddNewReportingPeriodRequest
  ): Promise<Response> => {
    return SubFundService.postNewReportingPeriod(
      addNewReportingPeriodRequest
    ).then((data: Response) => data);
  },
  [AT.DELETE_SUB_FUND_COST]: (
    { commit },
    deleteSubFundCostRequest: DeleteSubFundCostRequest
  ): Promise<Response> => {
    return SubFundService.deleteSubFundCost(deleteSubFundCostRequest).then(
      (data: Response) => data
    );
  }
};

/**
 * --------------------------------------------------
 *  SubFund Action Context Interface
 * --------------------------------------------------
 **/
export interface ISubFundActionContext
  extends ActionContext<ISubFundState, IRootState> {}

/**
 * --------------------------------------------------
 *  SubFund Actions Interface
 * --------------------------------------------------
 **/
export interface ISubFundActions extends ActionTree<ISubFundState, IRootState> {
  [AT.FETCH_ORGANISATION_SUB_FUNDS](
    context: ISubFundActionContext,
    organizationSubFundRequest: OrgSubFundRequest
  ): Promise<SubFund[]>;
  [AT.FETCH_ORGANISATION_FILTER_SUB_FUNDS](
    context: ISubFundActionContext,
    organizationSubFundRequest: OrgSubFundRequest
  ): Promise<SubFund[]>;
  [AT.ADD_SUB_FUND](
    context: ISubFundActionContext,
    addSubFundRequest: AddSubFundRequest
  ): Promise<Response>;
  [AT.UPDATE_SUB_FUND](
    context: ISubFundActionContext,
    updateSubFundRequest: UpdateSubFundRequest
  ): Promise<Response>;
  [AT.DELETE_SUB_FUND](
    context: ISubFundActionContext,
    deleteSubFundRequest: DeleteSubFundRequest
  ): Promise<Response>;
  [AT.SUB_FUND_COST](
    context: ISubFundActionContext,
    subFundCostRequest: SubFundCostRequest
  ): Promise<Response>;
  [AT.ADD_NEW_REPORTING_PERIOD](
    context: ISubFundActionContext,
    addNewReportingPeriodRequest: AddNewReportingPeriodRequest
  ): Promise<Response>;
  [AT.DELETE_SUB_FUND_COST](
    context: ISubFundActionContext,
    deleteSubFundCostRequest: DeleteSubFundCostRequest
  ): Promise<Response>;
}
